import React, { Component } from 'react'
import {connect} from 'react-redux'

import { deleteCourses } from '../../actions/Courses'

import Modal from '../Modal'

class DeleteCourse extends Component {
  deleteCourses () {
    this.props.deleteCourses({ id: this.props.course.id })
  }
  render () {
    const { ajaxStatus } = this.props.courses
    const c = this.props.course
    return (
      <Modal>
        <h3>Eliminare corso</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        {c.name}
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteCourses()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteCourses })(DeleteCourse)



// WEBPACK FOOTER //
// ./src/components/Courses/DeleteCourse.js